import React, { Component } from 'react';
import { getListSpacing, resolveBadgeColors, getBadgeBoxStyle, getTextBoxStyle } from '../../lib/global/helpers';
import { CURRENT_DATE_TIME_FIELD, COLUMN_TOTAL_FIELD, CALCULATION_FIELD, formatDateTime } from '../../lib/bands/bandModel';
import ListLines from './ListLines';
import { calculationName } from './new/CalculationTool';
import { describeCondition } from './new/VisibilitySettings';

class TemplateElement extends Component {
    constructor(props) {
        super(props);
        this.elementRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.onMount && this.props.elementId) {
            this.props.onMount(this.props.elementId, this.elementRef.current);
        }
    }

    componentWillUnmount() {
        if (this.props.onUnmount && this.props.elementId) {
            this.props.onUnmount(this.props.elementId);
        }
    }

    render() {
        const { element, isSelected, isGroupSelected, onClick, dataAttributes } = this.props;
        // The box grows with its text; its saved height is a minimum.
        const style = getTextBoxStyle(this.props.style);

        // Duplicated company fields are ordinary elements bound to a company
        // field, so this is set by the company field list, not the name.
        const isCompanyProp = element.section === "head" && !!element.isCompanyProp;

        const dataPath = isCompanyProp ? "companyProps" : "elements";
        const dataIndex = element.name ? element.name.replace(/\./g, "") : "";

        const isList = style.listStyleType && style.listStyleType !== 'none';
        // The current date & time shows as it would print right now.
        const isDateTime = element.data === CURRENT_DATE_TIME_FIELD;
        // A column total shows which column it totals ({ColumnTotal} alone
        // wouldn't say).
        const totalConfig = element.data === COLUMN_TOTAL_FIELD ? element.columnTotal || {} : null;
        // A calculation shows what it adds up: {Net Total + Delivery Charges}.
        const shownText = isDateTime
            ? formatDateTime(new Date(), element.format?.pattern || 'DD/MM/YYYY HH:mm', element.timeZone)
            : totalConfig
                ? (element.text || '').split(`{${COLUMN_TOTAL_FIELD}}`).join(`{Total ${totalConfig.column || ''}${totalConfig.splitByUnit ? ' per unit' : ''}}`)
                // A calculation shows only its name; its values are in the
                // properties panel and the tooltip, since they can be long.
                : element.data === CALCULATION_FIELD
                    ? (element.text || '').split(`{${CALCULATION_FIELD}}`).join(`{${calculationName(element)}}`)
                    : element.text;
        const textLines = shownText ? shownText.split('\n') : [''];

        // The canvas shows the field name rather than real data, so a badge
        // is drawn in its default colours unless the text matches a rule.
        const badgeColors = resolveBadgeColors(element, element.text);
        const badgeBox = isList ? null : getBadgeBoxStyle(element, element.text);

        const elementStyle = {
            ...style,
            ...(badgeColors?.color ? { color: badgeColors.color } : {}),
            // Raised while selected, unless the user has set its stacking order.
            zIndex: isSelected && !Number.isFinite(element.layer) ? 999 : (style.zIndex || 1)
        };

        const hasLink = !!element.link;
        // Fields shown only when their value passes a check get a marker.
        const condition = describeCondition(element.showWhen);

        return (
            <div
                ref={this.elementRef}
                onClick={onClick}
                style={elementStyle}
                id={element.id}
                data-group-id={element.groupId}
                data-element={element.name}
                data-section={element.section}
                data-path={dataPath}
                data-index={dataIndex}
                {...dataAttributes}
                className={"custom-element" + (isSelected ? " selected-element" : "") + (isGroupSelected ? " group-selected-element" : "") + (hasLink ? " has-link" : "") + (condition ? " has-condition" : "")}
                title={hasLink ? `Links to: ${element.link}` : isDateTime ? "Current date & time — filled in when the document is printed" : element.data === CALCULATION_FIELD ? `${calculationName(element)} = ${this.props.calculationLabel || "nothing added yet"}` : condition ? `Shown only when the value ${condition}` : undefined}
            >
                {isList ? (
                    <ListLines
                        lines={textLines}
                        type={style.listStyleType}
                        spacing={getListSpacing(element)}
                        textStyle={{
                            color: elementStyle.color,
                            fontSize: style.fontSize,
                            lineHeight: style.lineHeight,
                            fontFamily: style.fontFamily,
                            fontWeight: style.fontWeight,
                            fontStyle: style.fontStyle,
                            textDecoration: style.textDecoration,
                            textAlign: style.textAlign
                        }}
                    />
                ) : badgeBox ? (
                    <span style={badgeBox}>{shownText}</span>
                ) : (
                    shownText
                )}
                {isSelected ? this.props.renderElementControl?.() : <></>}
            </div>
        );
    }
}

export default TemplateElement;